import React from "react";
import "./style.css";

function ResultSuccess(){

    return(
<>
<div id="emailSuccess">
    Your Message Has Been Sent!
</div>

</>
    )
}

export default ResultSuccess;